function renderInline(text, keyBase) {
  const parts = String(text).split(/\*\*(.+?)\*\*/g);
  return parts.map((p, i) =>
    i % 2 === 1 ? <strong key={`${keyBase}-${i}`} className="font-semibold text-sand-950">{p}</strong> : p
  );
}

export default function Markdown({ text }) {
  const blocks = [];
  let list = null;
  let table = null;
  (text || "").split("\n").forEach((line) => {
    const t = line.trim();
    if (/^\|.*\|$/.test(t)) {
      list = null;
      const cells = t.slice(1, -1).split("|").map((c) => c.trim());
      if (cells.every((c) => /^:?-{2,}:?$/.test(c))) return; // separator row
      if (!table) { table = { type: "table", rows: [] }; blocks.push(table); }
      table.rows.push(cells);
      return;
    }
    table = null;
    const isBullet = /^[-*•] /.test(t);
    const isNum = /^\d+[.)] /.test(t);
    if (isBullet || isNum) {
      if (!list || list.type !== (isNum ? "ol" : "ul")) {
        list = { type: isNum ? "ol" : "ul", items: [] };
        blocks.push(list);
      }
      list.items.push(t.replace(/^[-*•] /, "").replace(/^\d+[.)] /, ""));
    } else {
      list = null;
      if (/^-{3,}$/.test(t)) blocks.push({ type: "hr" });
      else if (/^#{1,4} /.test(t)) blocks.push({ type: "h", text: t.replace(/^#{1,4} /, "") });
      else if (/^> /.test(t)) blocks.push({ type: "q", text: t.replace(/^> /, "") });
      else if (t) blocks.push({ type: "p", text: t });
    }
  });
  return (
    <div className="space-y-2 text-sm leading-relaxed text-sand-800">
      {blocks.map((b, i) => {
        if (b.type === "h")
          return <p key={i} className="font-display font-medium text-base text-sand-950 pt-1">{renderInline(b.text, i)}</p>;
        if (b.type === "hr") return <div key={i} className="border-t border-sand-200 my-1" />;
        if (b.type === "q")
          return <p key={i} className="border-l-2 border-ember pl-3 text-sand-700 bg-sand-50 py-1.5">{renderInline(b.text, i)}</p>;
        if (b.type === "table") {
          const [head, ...rows] = b.rows;
          return (
            <div key={i} className="overflow-x-auto">
              <table className="w-full text-xs border border-sand-200">
                <thead>
                  <tr className="bg-sand-50">
                    {head.map((c, j) => <th key={j} className="text-left font-semibold px-2.5 py-1.5 border-b border-sand-200">{renderInline(c, `${i}-h${j}`)}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, j) => (
                    <tr key={j} className="border-b border-sand-100 last:border-0">
                      {r.map((c, k) => <td key={k} className="px-2.5 py-1.5 align-top">{renderInline(c, `${i}-${j}-${k}`)}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        if (b.items) {
          const Tag = b.type;
          return (
            <Tag key={i} className={`pl-5 space-y-1 ${b.type === "ol" ? "list-decimal" : "list-disc"}`}>
              {b.items.map((it, j) => <li key={j}>{renderInline(it, `${i}-${j}`)}</li>)}
            </Tag>
          );
        }
        return <p key={i}>{renderInline(b.text, i)}</p>;
      })}
    </div>
  );
}
